<template>
    <article class="card big-announcement">

      <link-to v-if="link" class="card__image" :to="link">
        <div class="cover" :class="{'no_images': isImages}" :style="'background-image: url('+ (this.isImages ? this.isImages : image) +');'"></div>
      </link-to>

      <div class="card__image" v-else>
        <div class="cover" :class="{'no_images': isImages}" :style="'background-image: url('+ (this.isImages ? this.isImages : image) +');'"></div>
      </div>

      <page-columns class="card__columns" :reverse="false" :column_full="true">
        <template slot="first">
          <div class="card__content">
            <div class="card__meta" v-if="date">
              <span class="event-date" v-html="date"></span>
            </div>
            <h3 v-if="title" v-html="title"></h3>
          </div>
        </template>
        <template slot="last" >
          <div class="card description font-size-1">
            <slot></slot>
            <div class="card__actions" :class="{ 'center': buttonShow}" v-if="!linkRef">
              <LinkTo class="text-black solid" v-if="more" :to="link">Читать далее...</LinkTo>
              <LinkTo class="btn solid--green large" v-if="buttonShow" :to="link">Подробнее</LinkTo>
            </div>
            <div class="card__actions" :class="{ 'center': buttonShow}" v-else>
              <a class="text-black solid" v-if="more" :href="linkRef">Читать далее...</a>
              <a class="btn solid--green large" v-if="buttonShow" :href="linkRef">Подробнее</a>
            </div>
          </div>
        </template>

      </page-columns>

    </article>
  </template>

<script>
  import NewsItemMixin from '../mixins/NewItemMixin.js'
  export default {
    props: {
      title: String,
      date: String,
      image: String,
      id: String,
      link: String,
      linkRef: String,
      more: Boolean,
      buttonShow: Boolean
    },
    mixins: [NewsItemMixin],
    data() {
      return {
        sizeImgError: '1200x500',
        isImages: false,
      };
    },
  }
</script>

<style lang="scss" scoped>
  .card {
    padding: 5px 0;
    margin-bottom: 45px;
    &__image {
      display: block;
      @include ease(opacity);
      margin-bottom: 35px;
      @media (max-width: 600px) {
        margin-bottom: 15px;
      }
      &:hover {
        opacity: 0.9;
      }
      .cover {
        &.no_images {
          background: #a7a7a7 !important;
        }
        @include size(100%, 500px);
        @include background-cover();
        @media (max-width: $media_md) {
          height: 400px;
        }
        @media (max-width: 600px) {
          height: 300px;
        }
        @media (max-width: 400px) {
          height: 250px;
        }
      }
    }

    &__meta {
      padding-bottom: 8px;
      font-size: 20px;
      text-transform: uppercase;
    //  font-weight: bold;
      height: 30px;
      @media (max-width: 600px) {
        padding: 10px 0 10px;
        height: auto;
      }
    }
    &.description {
      margin-bottom: 15px;
    }
    &__actions {
      text-align: left;
      margin-top: 15px;
      &.center {
        margin-top: 25px;
        text-align: center;
        line-height: initial;
      }
    }

    @media (max-width: $media_sm) {

      &.big-announcement {
        padding: 0px 0 20px 0;
        margin-bottom: 10px;
      }

      h3 {
        text-transform: none;
        font-size: 18px;
      }
      &.description {
        margin-bottom: 0px;
        padding: 5px 0;
      }
      &__image {

      }
      &__meta {
        font-size: 16px;
      }
      &__actions {
       // display: none;
      }
    }
    @media (max-width: 400px) {

      margin-bottom: 25px;
    }

  }
</style>



// WEBPACK FOOTER //
// components/shared/sliders/NewsBigSlide.vue